import React from 'react';
import { FormattedMessage } from 'react-intl';
import { call } from '../utilities/http';
import { Snackbar } from '../components/snackbar';
import { LOADING, COMPLETE, WIZARD_CHANGE_MENU_STATE, WIZARD_SET_PROGRESS } from './types';

const defaultState = {
    menuActive: false,
    progress: undefined
};

/**
 * Wizard state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case WIZARD_CHANGE_MENU_STATE:
            return { ...state, menuActive: action.data };

        case WIZARD_SET_PROGRESS:
            return { ...state, progress: action.data };

        default:
            return state;
    }
}

export function setMenuState(state) {
    return async function(dispatch) {
        dispatch({ type: WIZARD_CHANGE_MENU_STATE, data: state });
    };
}

export function setProgress(configuration, progress, onSuccess = () => null) {
    let errorMessage = <FormattedMessage id={'error.setProgress'} defaultMessage={'Unable to persist wizard progress.'} />;

    const { id, entity } = configuration;

    return async function(dispatch) {
        dispatch({ type: LOADING });
        if (id === undefined) {
            dispatch({ type: WIZARD_SET_PROGRESS, data: progress });
            onSuccess(progress);
            dispatch({ type: COMPLETE });
            return;
        }

        call({ path: `/${entity}/${id}/progress`, method: 'POST', body: progress })
            .then(response => {
                dispatch({ type: WIZARD_SET_PROGRESS, data: progress });
                onSuccess(response);
                dispatch({ type: COMPLETE });
            })
            .catch(() => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/wizard.jsx